module.exports = __webpack_public_path__ + "static/media/ceragon.c6284045.svg";